<template>
  <div>
    <b-table
      small
      responsive
      hover
      class="mt-3"
      :items="userList"
      primary-key="id"
    >
      <template #head(_id)>
        <span style="display: none">{{ $t("ID") }}</span>
      </template>
      <template #cell(_id)>
        <!-- <span>{{ data.item._id }}</span> -->
      </template>
      <template #head(for)>
        <span>{{ $t("User") }}</span>
      </template>
      <template #head(status)>
        <span>{{ $t("Status") }}</span>
      </template>
      <template #cell(for)="data">
        <b-link :to="{ name: 'user-perms', params: { id: data.item.for._id } }">
          <b-button variant="primary">
            {{ data.item.for.displayName || data.item.for.name }}
          </b-button>
        </b-link>
      </template>
      <template #head(type)>
        <span>{{ $t("Type") }}</span>
      </template>
      <template #cell(type)="data">
        <span>{{ data.item.type }}</span>
      </template>
      <template #cell(status)>
        <b-button
          class="btn-icon m-1"
          variant="success"
        >
          <feather-icon icon="CheckCircleIcon" />
        </b-button>
        <b-button
          variant="danger"
          class="btn-icon m-1"
        >
          <feather-icon icon="XCircleIcon" />
        </b-button>
      </template>
    </b-table>
  </div>
</template>

<script>
import {
  BTable, BButton, BLink,
} from 'bootstrap-vue'
import axios from '@axios'

const {
  axiosRoutes: { approval: path },
} = require('../../../../G_CONFIG')

export default {
  components: {
    BTable,
    BButton,
    BLink,
  },
  data() {
    return {
      userList: null,
      permissionsData: [
        {
          module: 'Admin',
          read: true,
          write: false,
          create: false,
          delete: false,
        },
        {
          module: 'Staff',
          read: false,
          write: true,
          create: false,
          delete: false,
        },
        {
          module: 'Author',
          read: true,
          write: false,
          create: true,
          delete: false,
        },
        {
          module: 'Contributor',
          read: false,
          write: false,
          create: false,
          delete: false,
        },
        {
          module: 'User',
          read: false,
          write: false,
          create: false,
          delete: true,
        },
      ],
    }
  },
  async created() {
    /* console.log(this.permissionsData); */
    await axios.get(path.getAll).then(response => {
      this.userList = response.data
    })
    // console.log(this.userList);
  },
}
</script>
<style scoped></style>
